import React, {useEffect} from 'react';
import {connect} from "react-redux";
import Loader from "./layout/loading/loader";
import ButtonCreate from "./layout/ButtonCreate";
import Constants from "../../utils/constants";
import {Business} from "@mui/icons-material";
import PageTitle from "./layout/PageTitle";
import {agencesActions} from "../../modules/agences/agences.actions";
import AgencesTable from "./agences/AgencesTable";
import {Stack} from "@mui/material";

function AgencesPage({dispatch, ...props}) {
	useEffect(() => {
		if (!props.agences && !props.loading && !props.error) {
			dispatch(agencesActions.fetchAgences());
		}
	}, [dispatch, props.agences]);

	const handleDelete = (a) => {
		dispatch(agencesActions.deleteAgence(a.id));
	};

	return (
	  <>
		  <Stack direction="row" justifyContent={"space-between"} spacing={2}>
			  <PageTitle title={"Gestion des agences"} icon={<Business/>}/>
			  <ButtonCreate route={Constants.APP_ROUTE_ADMIN_AGENCES_NEW} label={"Ajouter une agence"}/>
		  </Stack>

		  {props.loading && <Loader/>}
		  {!props.loading &&
			<AgencesTable agences={props.agences} onDelete={handleDelete}/>
		  }
	  </>
	);
}

const mapStateToProps = function (state) {
	return {
		agences: state.agences.agences,
		loading: state.agences.loading,
		error: state.agences.error,
	};
};

export default connect(mapStateToProps)(AgencesPage);
